import { mergeAttributes, Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import Component from './Component';
import { PAGE_BREAK_NODE_NAME } from './constants';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    'page-break': {
      insertPageBreak: () => ReturnType;
    };
  }
}

const PageBreakNode = Node.create({
  name: PAGE_BREAK_NODE_NAME,

  inline: false,
  group: 'block',
  atom: true,

  draggable: true,
  selectable: true,

  parseHTML() {
    return [
      {
        tag: 'div.page-break',
      },
    ];
  },

  renderHTML({ node, HTMLAttributes }) {
    return ['div', mergeAttributes({ class: 'page-break' }, HTMLAttributes)];
  },

  addNodeView() {
    return ReactNodeViewRenderer(Component, { as: 'div', trackNodeViewPosition: true });
  },

  /*
  renderHTML({ HTMLAttributes }) {
    return ['page-break', HTMLAttributes];
  },

  parseHTML() {
    return [
      {
        tag: 'page-break',
      },
    ];
  },
  */

  addCommands() {
    return {
      // ...this.parent?.(),
      insertPageBreak:
        () =>
        ({ commands }) => {
          return commands.insertContent({ type: this.name });
        },
    };
  },
});

export default PageBreakNode;
